import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { ClaimCountersHttpClient } from './claim-counters.http-client';
import { ReferralsClaimCounterActions } from './claim-counters.store';

@Injectable({ providedIn: 'root' })
export class ReferralsClaimCountersEffects {
  public effects = createEffectFactory(ReferralsClaimCounterActions, this.actions$);

  public fetch$ = this.effects(ReferralsClaimCounterActions.fetch, () =>
    this.http.loadApplicationsCounters().pipe(map(data => ({ counters: data }))),
  );

  constructor(
    private actions$: Actions,
    private http: ClaimCountersHttpClient,
  ) {}
}
